/**
 * UI interaction handlers
 */

/**
 * Show status message
 * @param {string} message - Message to display
 * @param {string} type - Message type: 'success', 'error', 'loading'
 */
export function showStatus(message, type = 'loading') {
  const statusEl = document.getElementById('status-message');
  statusEl.textContent = message;
  statusEl.className = type;
}

/**
 * Clear status message
 */
export function clearStatus() {
  const statusEl = document.getElementById('status-message');
  statusEl.textContent = '';
  statusEl.className = '';
}

/**
 * Show node details in sidebar
 * @param {object} node - Node data
 */
export function showNodeDetails(node) {
  const detailsEl = document.getElementById('node-details');
  const labelEl = document.getElementById('detail-label');
  const descEl = document.getElementById('detail-description');
  const categoryEl = document.getElementById('detail-category');

  labelEl.textContent = `${node.emoji || '📌'} ${node.label}`;
  descEl.textContent = node.description || 'No description available';
  categoryEl.textContent = node.category || 'Uncategorized';

  detailsEl.classList.remove('hidden');
}

/**
 * Hide node details
 */
export function hideNodeDetails() {
  const detailsEl = document.getElementById('node-details');
  detailsEl.classList.add('hidden');
}

/**
 * Enable/disable analyze button
 * @param {boolean} enabled
 */
export function setAnalyzeButtonState(enabled) {
  const btn = document.getElementById('analyze-btn');
  btn.disabled = !enabled;
  btn.textContent = enabled ? 'Generate Graph' : 'Analyzing...';
}

/**
 * Get text input value
 * @returns {string}
 */
export function getTextInput() {
  return document.getElementById('text-input').value.trim();
}

/**
 * Clear text input
 */
export function clearTextInput() {
  document.getElementById('text-input').value = '';
}
